import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/antd.css';
import {ConfigProvider} from 'antd'
import esES from 'antd/es/locale/es_ES';
import { BrowserRouter } from 'react-router-dom';
import App from './components/app/App';
import {Provider} from 'react-redux'
import * as serviceWorker from './serviceWorker';
import store from './store/store'
import moment from 'moment'
import 'moment/locale/es-us';
moment.locale('es');

const PrincipalComponent = () => (
    <ConfigProvider locale={esES}>
        <BrowserRouter>
        <Provider store={store}>
            <App />
        </Provider>
        </BrowserRouter>
    </ConfigProvider>
   
);

ReactDOM.render(<PrincipalComponent />, document.getElementById('root'));
serviceWorker.unregister();
